'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = BreadcrumbItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _list = require('../list');

var _navItem = require('../navItem');

require('./breadcrumb-item.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH BreadcrumbItem Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function BreadcrumbItem(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$isActive = props.isActive,
        isActive = _props$isActive === undefined ? false : _props$isActive,
        _props$href = props.href,
        href = _props$href === undefined ? '' : _props$href,
        _props$title = props.title,
        title = _props$title === undefined ? '' : _props$title,
        _props$target = props.target,
        target = _props$target === undefined ? '' : _props$target,
        _props$rel = props.rel,
        rel = _props$rel === undefined ? '' : _props$rel;

    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-breadcrumb__item': true,
        'sb-breadcrumb__item--active': isActive
    }, '' + className, className));

    return (0, _jsx3.default)(_list.ListItem, {
        className: classNames,
        id: id
    }, void 0, (0, _jsx3.default)(_navItem.NavItem, {
        rel: rel,
        href: href,
        title: title,
        target: target
    }, void 0, children));
}
// css

// components
//# sourceMappingURL=BreadcrumbItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/breadcrumb/BreadcrumbItem.js
// module id = 548
// module chunks = 0